import React from 'react';
import ExecutiveBranch from '../../executivebranch';

class AppModeControl extends React.Component {

  render() {
    return (
      <ExecutiveBranch from='AppModeControl' menus={this.props.menus} openDrawer={this.props.openDrawer} />
    );
  }
}

export default AppModeControl;
